import { AUDIT_ROOTS } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { AuditHubPage } from "@/features/audit/components/audit-hub-page";
import { useAuth } from "@/features/auth/store";

const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

// Every filter lives in the URL so a view can be sent as a link; anything malformed is dropped
// rather than failing the page.
const search = z.object({
  tab: z
    .enum([
      "activity",
      "sign-ins",
      "devices",
      "changes",
      "security",
      "retention",
    ])
    .optional()
    .catch(undefined),
  from: day.optional().catch(undefined),
  to: day.optional().catch(undefined),
  who: z.number().int().positive().optional().catch(undefined),
  device: z.enum(["web", "native"]).optional().catch(undefined),
  inactive: z.boolean().optional().catch(undefined),
  root: z.enum(AUDIT_ROOTS).optional().catch(undefined),
  source: z.enum(["web", "native"]).optional().catch(undefined),
  event: z
    .enum([
      "login_ok",
      "login_failed",
      "logout",
      "refresh_reuse",
      "sessions_revoked",
      "stepup_requested",
      "stepup_ok",
      "stepup_failed",
    ])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/_app/admin/audit-log")({
  validateSearch: search,
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (
      !can("audit.view") &&
      !can("audit.activity.view") &&
      !can("audit.security.view") &&
      !can("audit.purge")
    )
      throw redirect({ to: "/" });
  },
  component: AuditLogRoute,
});

function AuditLogRoute() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AuditHubPage
      search={s}
      onSearch={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        })
      }
    />
  );
}
